import type { GQL_ID } from '@@partner:graphql/types'
import type {
  PromocodeInfoQuery,
  PromocodeInfoVariables
} from '@@partner:graphql/query/order/promocodeInfo.gql'

import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import debounce from 'awesome-debounce-promise'

import { GQL_QUERY_PROMOCODE_INFO } from '@@partner:graphql/query/order/promocodeInfo.gql'

export const useOrderPromocodeInfo = (
  order_id: GQL_ID,
  promocode_id: GQL_ID = ''
) => {
  const canRefetch = order_id && promocode_id

  const { data, loading, error, refetch } = useQuery<
    PromocodeInfoQuery,
    PromocodeInfoVariables
  >(GQL_QUERY_PROMOCODE_INFO, {
    variables: {
      order_id,
      promocode_id
    },
    fetchPolicy: 'network-only',
    skip: !canRefetch
  })

  const refetchOrderPromocodeDebounced = useMemo(
    () => debounce(refetch, 500, { onlyResolvesLast: true }),
    [ refetch ]
  )

  return {
    promocode: data?.promocodeInfo ?? null,
    refetch: refetchOrderPromocodeDebounced,
    loading,
    canRefetch,
    error
  }
}
